module.exports = __webpack_public_path__ + "static/media/sickle.1cf0a574.svg";